import { XauditModel } from "../../xaudit.model";

export class SurgicalDiagnosisModel extends XauditModel{
    SurgicalDiagosisID: string;
    PatientID: string;
    CaseWorkItemFormsId: string;
    CaseWorkItemToothId: string;
    MTEToothID: string;
    Description: string;
    thisDiagnosisCompleted: Date;
    Assistant_UserID: string;
    enumSurgeryTypeId: string;
    isRetreatment: boolean = false;
    isRoot_M: boolean = false;
    isRoot_MB: boolean = false;
    isRoot_D: boolean = false;
    isRoot_DB: boolean = false;
    isRoot_B: boolean = false;
    isRoot_S: boolean = false;
    isRoot_L: boolean = false;
    isRoot_Furca: boolean = false;
    isFloorOfNose: boolean = false;
    isMaxSinus: boolean = false;
    isMentalN: boolean = false;
    isMandibN: boolean = false;
    isExtOblRidge: boolean = false;
    isLackOfAttachGing: boolean = false;
    isFrenumAttach: boolean = false;
    isShortRoots: boolean = false;
    isLingRootIncl: boolean = false;
    isMuscleCTFlexibility: boolean = false;
    isFrenumAttachTori: boolean = false;
    isFrenumAttachToriB: boolean = false;
    isFrenumAttachToriL: boolean = false;
    isPossibleToothFracture: boolean = false;
    isLaterRootLesion: boolean = false;
    isRootPerforation: boolean = false;
    isFurcalPerforation: boolean = false;
    isSeparatedInstrument: boolean = false;
    isCalcifiedCanalTC: boolean = false;
    isLingualRoot: boolean = false;
    isComplicatedAnatomy: boolean = false;
    isImplantProximity: boolean = false;
    isPerioEndo: boolean = false;
    isPerioTC: boolean = false;
    isEndo: boolean = false;
    isCompliance: boolean = false;
    isExtResorption: boolean = false;
    isThruThru: boolean = false;
    isFutureImplantConsideration: boolean = false;
    isFurcalInvolvement: boolean = false;
    isFurcalInvolvementLVL1: boolean = false;
    isFurcalInvolvementLVL2: boolean = false;
    isFurcalInvolvementLVL3: boolean = false;
    isCSP: boolean = false;
    isPerforation: boolean = false;
    isPriorFailingSurgery: boolean = false;
    isCalcifiedCanalPE: boolean = false;
    isAnomalousAnatomy: boolean = false;
    isCombined: boolean = false;
    isPerioPE: boolean = false;
    isHistoryOfTrauma: boolean = false;
    isUnknownIndeterminate: boolean = false;
    isGranuloma: boolean = false;
    isCyst: boolean = false;
    isNeoplasm: boolean = false;
    isNonOdontogenic: boolean = false;
    enumSurgeryPreOpPrognosisId: string;
  };